/**
 * Auto generated build file to add global access to
 * provided methods
 */

import SelectTableFilterTemplate from './controllers/select-table-filter-template-controller';

Stimulus.register('select-table-filter-template', SelectTableFilterTemplate);
